<template>
  <v-col
    cols="6"
    class="offset-md-3"
  >
    <validation-observer
      v-slot="{ invalid, validated, passes }"
      ref="form"
    >
      <v-form>
        <v-container>
          <v-row
            align="center"
          >
            <v-col
              class="form-row"
              cols="12"
            >
              <validation-provider
                v-slot="{ errors }"
                name="password"
                rules="required|minPassword:8"
              >
                <v-text-field
                  v-model="password"
                  :error-messages="errors"
                  label="Password"
                  type="password"
                  autocomplete="new-password"
                  required
                />
              </validation-provider>
            </v-col>
            <v-col
              class="form-row"
              cols="12"
            >
              <validation-provider
                v-slot="{ errors }"
                name="confirmation"
                rules="password:@password"
              >
                <v-text-field
                  v-model="confirmPassword"
                  :error-messages="errors"
                  label="Confirm password"
                  type="password"
                  autocomplete="new-password"
                  required
                />
              </validation-provider>
            </v-col>
            <v-spacer />
            <v-col
              v-if="serverError"
              cols="12"
            >
              <v-alert
                :tile="true"
                type="error"
              >
                {{ serverError }}
              </v-alert>
            </v-col>
            <v-col
              class="form-row"
              cols="5"
            >
              <v-btn
                block
                large
                @click="passes(submit)"
              >
                Reset your password
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </validation-observer>
  </v-col>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import http from '@/http';

export default {
  name: 'ResetPasswordPage',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      serverError: '',
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        await http.request({
          url: '/auth/users/reset_password_confirm/',
          method: 'post',
          data: {
            new_password: this.password,
            ...this.$route.params,
          },
        });
        this.$router.push({ name: 'home' });
      } catch (err) {
        const { data } = (err.response || {});
        if (data && data.new_password) {
          this.$refs.form.setErrors({
            password: data.new_password,
          });
          return;
        }
        this.serverError = 'Invalid reset password link';
      }
    },
  },
};
</script>
